// removed by extract-text-webpack-plugin
module.exports = {"breadcrumbs":"_36p9m","breadcrumb":"_1jdA0","breadcrumbDivider":"_12IP7","breadcrumbPath":"j60xs","breadcrumbPage":"_3EYaf","sidebarBreadcrumbs":"_1yuel _1-OXK _36p9m","sidebarBreadcrumb":"_3Ngh0 _1jdA0"};


//////////////////
// WEBPACK FOOTER
// ./components/Breadcrumbs.css
// module id = 2061
// module chunks = 3